import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-719df345"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "管理详情", -1))
const _hoisted_3 = { class: "detail-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CosFixFooterPage = _resolveComponent("CosFixFooterPage")!
  const _directive_trim = _resolveDirective("trim")!

  return (_openBlock(), _createBlock(_component_CosFixFooterPage, null, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        "html-type": "submit",
        onClick: _ctx.handleSubmit,
        disabled: !_ctx.showEditDetail
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_spin, { spinning: _ctx.spinning }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_form, {
                model: _ctx.formState,
                ref: "formDetail",
                name: "basic",
                "wrapper-col": { span: 22 },
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "上级名称",
                    name: "topName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formState.topName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.topName) = $event)),
                        maxlength: 100,
                        disabled: true
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "名称",
                    name: "areaName",
                    rules: [{ required: true, message: '不可为空！' }]
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_a_input, {
                        value: _ctx.formState.areaName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.areaName) = $event)),
                        maxlength: 100,
                        placeholder: "请输入",
                        disabled: !_ctx.showEditDetail
                      }, null, 8, ["value", "disabled"]), [
                        [_directive_trim]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "顺序",
                    name: "sort",
                    rules: [{ required: true, message: '不可为空！' }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_number, {
                        value: _ctx.formState.sort,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.sort) = $event)),
                        min: 0,
                        placeholder: "请输入",
                        disabled: !_ctx.showEditDetail
                      }, null, 8, ["value", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _: 1
        }, 8, ["spinning"])
      ])
    ]),
    _: 1
  }))
}